import React, { Component } from 'react';
import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';
import HomePage from '../../components/HomePage/HomePage';
import Test from '../../components/Test/Test';
import Picker from '../../components/Picker/Picker';

import PickerChannelOptions from '../../components/Picker/PickerChannelOptions';
import PickerResults from '../../components/Picker/Results';
import '../../assets/styles/fonts.scss';

import { Route, Switch } from "react-router-dom";

import './App.css';
// Sentry.init({
//   dsn: "https://e5636c3c490643908598c23594cdae09@o436330.ingest.sentry.io/5406988",
//   integrations: [
//     new Integrations.BrowserTracing(),
//   ],
//   tracesSampleRate: 1.0,
// });
class App extends Component {
  render() {
    return (
        <div className="App">
          <Switch>
            <Route exact path="/home" component={HomePage} />
            <Route exact path="/test" component={Test} />
            <Route exact path="/" component={Picker} />
            <Route exact path="/picker/channel-options" component={PickerChannelOptions} />
            <Route exact path="/picker/results" component={PickerResults} />
          </Switch>
        </div>
    );
  }
}

App.propTypes = {

};

export default App;



// WEBPACK FOOTER //
// ./src/containers/App/App.js